export const env = <T = string, R = T>(
  key: string,
  opts?: {
    default?: T;
    transform?: (value: T) => R;
  },
): R => {

  const value = import.meta.env[key] ?? opts?.default;

  if (typeof value === 'undefined') {

    throw new Error(`env key: ${key} is undefined. Make sure it's defined`);

  }

  if (opts?.transform) {

    return opts.transform(value as T);

  }

  return value as unknown as R;

};
